/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Select_Existing_ContactInputs */

const en_admin_external_booking_edit_select_existing_contact = /** @type {(inputs: Admin_External_Booking_Edit_Select_Existing_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select existing contact`)
};

const de_admin_external_booking_edit_select_existing_contact = /** @type {(inputs: Admin_External_Booking_Edit_Select_Existing_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestehenden Kontakt auswählen`)
};

const es_admin_external_booking_edit_select_existing_contact = /** @type {(inputs: Admin_External_Booking_Edit_Select_Existing_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar contacto existente`)
};

const fr_admin_external_booking_edit_select_existing_contact = /** @type {(inputs: Admin_External_Booking_Edit_Select_Existing_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner un contact existant`)
};

const nl_admin_external_booking_edit_select_existing_contact = /** @type {(inputs: Admin_External_Booking_Edit_Select_Existing_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestaand contact selecteren`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Select_Existing_ContactInputs) => LocalizedString} */
const it_admin_external_booking_edit_select_existing_contact = en_admin_external_booking_edit_select_existing_contact;

/** @type {(inputs: Admin_External_Booking_Edit_Select_Existing_ContactInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_select_existing_contact = en_admin_external_booking_edit_select_existing_contact;

/** @type {(inputs: Admin_External_Booking_Edit_Select_Existing_ContactInputs) => LocalizedString} */
const pl_admin_external_booking_edit_select_existing_contact = en_admin_external_booking_edit_select_existing_contact;

/** @type {(inputs: Admin_External_Booking_Edit_Select_Existing_ContactInputs) => LocalizedString} */
const hu_admin_external_booking_edit_select_existing_contact = en_admin_external_booking_edit_select_existing_contact;

/** @type {(inputs: Admin_External_Booking_Edit_Select_Existing_ContactInputs) => LocalizedString} */
const ro_admin_external_booking_edit_select_existing_contact = en_admin_external_booking_edit_select_existing_contact;

/**
* | output |
* | --- |
* | "Select existing contact" |
*
* @param {Admin_External_Booking_Edit_Select_Existing_ContactInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_select_existing_contact = /** @type {((inputs?: Admin_External_Booking_Edit_Select_Existing_ContactInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Select_Existing_ContactInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_select_existing_contact(inputs)
	if (locale === "de") return de_admin_external_booking_edit_select_existing_contact(inputs)
	if (locale === "es") return es_admin_external_booking_edit_select_existing_contact(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_select_existing_contact(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_select_existing_contact(inputs)
	if (locale === "it") return it_admin_external_booking_edit_select_existing_contact(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_select_existing_contact(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_select_existing_contact(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_select_existing_contact(inputs)
	return ro_admin_external_booking_edit_select_existing_contact(inputs)
});
export { admin_external_booking_edit_select_existing_contact as "admin.external_booking_edit.select_existing_contact" }